// Figure Options - Flat asset paths for Shopify theme assets/
// Generated on: 2025-10-29T00:00:00.000Z

window.figureOptions = [
    {
        "id": "football-player",
        "name": "Football Player",
        "filename": "design-football-player.png"
    },
    {
        "id": "foot-ball",
        "name": "Football",
        "filename": "design-foot-ball.png"
    },
    {
        "id": "basketball-player",
        "name": "Basketball Player",
        "filename": "design-basketball-player.png"
    },
    {
        "id": "basketball-ball",
        "name": "Basketball",
        "filename": "design-basketball-ball.png"
    },
    {
        "id": "karate",
        "name": "Karate",
        "filename": "design-karate.png"
    },
    {
        "id": "karate2",
        "name": "Karate 2",
        "filename": "design-karate2.png"
    },
    {
        "id": "mountaineering",
        "name": "mountaineering",
        "filename": "design-mountaineering.png"
    },
    {
        "id": "tennis",
        "name": "tennis",
        "filename": "design-tennis.png"
    },
    {
        "id": "box",
        "name": "box",
        "filename": "design-box.png"
    },
    {
        "id": "aikido-female",
        "name": "aikido-female",
        "filename": "design-aikido-female.png"
    },
    {
        "id": "archery-female",
        "name": "archery-female",
        "filename": "design-archery-female.png"
    },
    {
        "id": "archery-male",
        "name": "archery-male",
        "filename": "design-archery-male.png"
    },
    {
        "id": "arm-wrestling",
        "name": "arm-wrestling",
        "filename": "design-arm-wrestling.png"
    },
    {
        "id": "badminton-ball",
        "name": "badminton-ball",
        "filename": "design-badminton-ball.png"
    },
    {
        "id": "badminton-racket",
        "name": "badminton-racket",
        "filename": "design-badminton-racket.png"
    },
    {
        "id": "ballet-left",
        "name": "ballet-left",
        "filename": "design-ballet-left.png"
    },
    {
        "id": "basketball-player-2",
        "name": "basketball-player-2",
        "filename": "design-basketball-player-2.png"
    },
    {
        "id": "basketball-player-female",
        "name": "basketball-player-female",
        "filename": "design-basketball-player-female.png"
    },
    {
        "id": "bike",
        "name": "bike",
        "filename": "design-bike.png"
    },
    {
        "id": "bowling",
        "name": "bowling",
        "filename": "design-bowling.png"
    },
    {
        "id": "boxing-female",
        "name": "boxing-female",
        "filename": "design-boxing-female.png"
    },
    {
        "id": "carting",
        "name": "carting",
        "filename": "design-carting.png"
    },
    {
        "id": "cheerleaders",
        "name": "cheerleaders",
        "filename": "design-cheerleaders.png"
    },
    {
        "id": "chess-king",
        "name": "chess-king",
        "filename": "design-chess-king.png"
    },
    {
        "id": "chess-queen",
        "name": "chess-queen",
        "filename": "design-chess-queen.png"
    },
    {
        "id": "dance-1",
        "name": "dance-1",
        "filename": "design-dance-1.png"
    },
    {
        "id": "discobolos",
        "name": "discobolos",
        "filename": "design-discobolos.png"
    },
    {
        "id": "firefighter",
        "name": "firefighter",
        "filename": "design-firefighter.png"
    },
    {
        "id": "fishing-1",
        "name": "fishing-1",
        "filename": "design-fishing-1.png"
    },
    {
        "id": "fittness-girl",
        "name": "fittness-girl",
        "filename": "design-fittness-girl.png"
    },
    {
        "id": "folk-dance",
        "name": "folk-dance",
        "filename": "design-folk-dance.png"
    },
    {
        "id": "golf",
        "name": "golf",
        "filename": "design-golf.png"
    },
    {
        "id": "gun-shooting-female",
        "name": "gun-shooting-female",
        "filename": "design-gun-shooting-female.png"
    },
    {
        "id": "gun-shooting-male",
        "name": "gun-shooting-male",
        "filename": "design-gun-shooting-male.png"
    },
    {
        "id": "gymnastics-girl-1",
        "name": "gymnastics-girl-1",
        "filename": "design-gymnastics-girl-1.png"
    },
    {
        "id": "gymnastics-girl-2",
        "name": "gymnastics-girl-2",
        "filename": "design-gymnastics-girl-2.png"
    },
    {
        "id": "gymnastics-girl-left",
        "name": "gymnastics-girl-left",
        "filename": "design-gymnastics-girl-left.png"
    },
    {
        "id": "gymnastics-men-2-left",
        "name": "gymnastics-men-2-left",
        "filename": "design-gymnastics-men-2-left.png"
    },
    {
        "id": "gymnastics-men",
        "name": "gymnastics-men",
        "filename": "design-gymnastics-men.png"
    },
    {
        "id": "handball-ball",
        "name": "handball-ball",
        "filename": "design-handball-ball.png"
    },
    {
        "id": "handball-female",
        "name": "handball-female",
        "filename": "design-handball-female.png"
    },
    {
        "id": "handball-male",
        "name": "handball-male",
        "filename": "design-handball-male.png"
    },
    {
        "id": "heart",
        "name": "heart",
        "filename": "design-heart.png"
    },
    {
        "id": "hockey-player",
        "name": "hockey-player",
        "filename": "design-hockey-player.png"
    },
    {
        "id": "hurdling",
        "name": "hurdling",
        "filename": "design-hurdling.png"
    },
    {
        "id": "javelin-throw",
        "name": "javelin-throw",
        "filename": "design-javelin-throw.png"
    },
    {
        "id": "judo-left",
        "name": "judo-left",
        "filename": "design-judo-left.png"
    },
    {
        "id": "karate-female-1",
        "name": "karate-female-1",
        "filename": "design-karate-female-1.png"
    },
    {
        "id": "karate-female-2",
        "name": "karate-female-2",
        "filename": "design-karate-female-2.png"
    },
    {
        "id": "karate-female-3",
        "name": "karate-female-3",
        "filename": "design-karate-female-3.png"
    },
    {
        "id": "karate-male-1",
        "name": "karate-male-1",
        "filename": "design-karate-male-1.png"
    },
    {
        "id": "karate-male-2",
        "name": "karate-male-2",
        "filename": "design-karate-male-2.png"
    },
    {
        "id": "karate-male-3",
        "name": "karate-male-3",
        "filename": "design-karate-male-3.png"
    },
    {
        "id": "karate-male-4",
        "name": "karate-male-4",
        "filename": "design-karate-male-4.png"
    },
    {
        "id": "kayak",
        "name": "kayak",
        "filename": "design-kayak.png"
    },
    {
        "id": "kickboxing-female",
        "name": "kickboxing-female",
        "filename": "design-kickboxing-female.png"
    },
    {
        "id": "kickboxing-male-1",
        "name": "kickboxing-male-1",
        "filename": "design-kickboxing-male-1.png"
    },
    {
        "id": "kickboxing-male-2",
        "name": "kickboxing-male-2",
        "filename": "design-kickboxing-male-2.png"
    },
    {
        "id": "long-jump-female",
        "name": "long-jump-female",
        "filename": "design-long-jump-female.png"
    },
    {
        "id": "long-jump-male",
        "name": "long-jump-male",
        "filename": "design-long-jump-male.png"
    },
    {
        "id": "moto-helmet",
        "name": "moto-helmet",
        "filename": "design-moto-helmet.png"
    },
    {
        "id": "motocross",
        "name": "motocross",
        "filename": "design-motocross.png"
    },
    {
        "id": "nordic-walking-female",
        "name": "nordic-walking-female",
        "filename": "design-nordic-walking-female.png"
    },
    {
        "id": "ocr-obstacles",
        "name": "ocr-obstacles",
        "filename": "design-ocr-obstacles.png"
    },
    {
        "id": "optimist",
        "name": "optimist",
        "filename": "design-optimist.png"
    },
    {
        "id": "pikado",
        "name": "pikado",
        "filename": "design-pikado.png"
    },
    {
        "id": "rowing",
        "name": "rowing",
        "filename": "design-rowing.png"
    },
    {
        "id": "runner-female",
        "name": "runner-female",
        "filename": "design-runner-female.png"
    },
    {
        "id": "runner-male-1",
        "name": "runner-male-1",
        "filename": "design-runner-male-1.png"
    },
    {
        "id": "shooting-female",
        "name": "shooting-female",
        "filename": "design-shooting-female.png"
    },
    {
        "id": "shooting-male",
        "name": "shooting-male",
        "filename": "design-shooting-male.png"
    },
    {
        "id": "shooting-target",
        "name": "shooting-target",
        "filename": "design-shooting-target.png"
    },
    {
        "id": "show-jumping",
        "name": "show-jumping",
        "filename": "design-show-jumping.png"
    },
    {
        "id": "skating-female-2",
        "name": "skating-female-2",
        "filename": "design-skating-female-2.png"
    },
    {
        "id": "skating-female",
        "name": "skating-female",
        "filename": "design-skating-female.png"
    },
    {
        "id": "skeet-shooting",
        "name": "skeet-shooting",
        "filename": "design-skeet-shooting.png"
    },
    {
        "id": "stars",
        "name": "stars",
        "filename": "design-stars.png"
    },
    {
        "id": "swimming-female",
        "name": "swimming-female",
        "filename": "design-swimming-female.png"
    },
    {
        "id": "swimming-male-1",
        "name": "swimming-male-1",
        "filename": "design-swimming-male-1.png"
    },
    {
        "id": "swimming-male-butterfly",
        "name": "swimming-male-butterfly",
        "filename": "design-swimming-male-butterfly.png"
    },
    {
        "id": "syncro-swimming-1",
        "name": "syncro-swimming-1",
        "filename": "design-syncro-swimming-1.png"
    },
    {
        "id": "syncro-swimming-2",
        "name": "syncro-swimming-2",
        "filename": "design-syncro-swimming-2.png"
    },
    {
        "id": "table-tennis",
        "name": "table-tennis",
        "filename": "design-table-tennis.png"
    },
    {
        "id": "trail-running-female",
        "name": "trail-running-female",
        "filename": "design-trail-running-female.png"
    },
    {
        "id": "trail-running-male-female",
        "name": "trail-running-male-female",
        "filename": "design-trail-running-male-female.png"
    },
    {
        "id": "trail-running-male",
        "name": "trail-running-male",
        "filename": "design-trail-running-male.png"
    },
    {
        "id": "triathlon",
        "name": "triathlon",
        "filename": "design-triathlon.png"
    },
    {
        "id": "trophy",
        "name": "trophy",
        "filename": "design-trophy.png"
    },
    {
        "id": "tug-of-war",
        "name": "tug-of-war",
        "filename": "design-tug-of-war.png"
    },
    {
        "id": "violin",
        "name": "violin",
        "filename": "design-violin.png"
    },
    {
        "id": "voleyball-female-2",
        "name": "voleyball-female-2",
        "filename": "design-voleyball-female-2.png"
    },
    {
        "id": "volleyball-ball",
        "name": "volleyball-ball",
        "filename": "design-volleyball-ball.png"
    },
    {
        "id": "volleyball-player-female",
        "name": "volleyball-player-female",
        "filename": "design-volleyball-player-female.png"
    },
    {
        "id": "volleyball-player-male",
        "name": "volleyball-player-male",
        "filename": "design-volleyball-player-male.png"
    },
    {
        "id": "waterpolo-female",
        "name": "waterpolo-female",
        "filename": "design-waterpolo-female.png"
    },
    {
        "id": "waterpolo-goal",
        "name": "waterpolo-goal",
        "filename": "design-waterpolo-goal.png"
    },
    {
        "id": "waterpolo-male",
        "name": "waterpolo-male",
        "filename": "design-waterpolo-male.png"
    },
    {
        "id": "weight-lifting-male",
        "name": "weight-lifting-male",
        "filename": "design-weight-lifting-male.png"
    },
    {
        "id": "weight-lifting-women",
        "name": "weight-lifting-women",
        "filename": "design-weight-lifting-women.png"
    },
    {
        "id": "wrestling-1",
        "name": "wrestling-1",
        "filename": "design-wrestling-1.png"
    }
];